import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal,NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';
import { Subject, Subscription } from 'rxjs';
import { breadcrumbItem } from 'src/app/components/breadcrumbs/breadcrumbs.model';
import { AlertService } from 'src/app/core/services/AlertService/alert.service';
import { DepartmentService } from 'src/app/core/services/employees/department/department.service';
import { locationBroadcastService } from 'src/app/core/services/loaction-broadcast.service';
import { BreadcrumbService } from "src/app/services/breadcrumb";
import { AppState } from 'src/app/store/app.state';
import { ApiService } from "src/app/services/api";
import { noWhiteSpaceValidator } from 'src/app/shared/directive/validators';

@Component({
  selector: 'app-quicksetting',
  templateUrl: './quicksetting.component.html',
  styleUrls: ['./quicksetting.component.scss'],
  providers: [NgbModalConfig, NgbModal],

})
export class QuicksettingComponent implements OnInit {

  isLoadingChangeSub = new Subject<boolean>();
  breadcrumbItems: breadcrumbItem[] = [
    {
      label:'Home',
      active:false,
      url:'/home'
    },
    {
      label: 'Merchant',
      active: false,
      url: "/merchants/merchant-home",
      // url:"/merchants"
    },
    {
      label: 'Quick Setting',
      active: true,
      url:" ",
    },
  ];



  faForm: FormGroup;

  storeId: any = "";
  params: any = new HttpParams();
  httpOptions = {};
  headerToken = {
    "Content-Type": "application/json",
    Authorization: this.cookieService.get("token"),
  };
  isLoading = false;
  GLOBALURL:any;
  constructor(
    private fb: FormBuilder,
    private cookieService: CookieService,
    private toastr: AlertService,
    private ApiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private BreadcrumbService: BreadcrumbService,
    private http: HttpClient,
    ) {

      this.GLOBALURL = this.ApiService.getBaseURL();
    }



  ngOnInit(): void {
    this.BreadcrumbService.setValue(this.breadcrumbItems);

    if (this.cookieService.check('permissionNameDepartment')) {
      this.storeId = this.cookieService.get('storeId');
      this.initForm()
      if (this.storeId == '*') {
        this.router.navigate(['/merchant-list']);
      }
    } else {
      this.router.navigate(['/home']);
    }


  }


  submitted=false
  onSubmit() {
    this.submitted=true
    if (this.faForm.valid) {
      let data = this.faForm.value
      let payload={
        username:(data.username || '').trim(),
      }
       return this.http
      .post(this.GLOBALURL + "/employee/disable2fa", payload, {
        headers: this.headerToken,
      })
      .subscribe(
        (response: any) => {
          if (response.success === 0) {
            this.toastr.error(response.message);
            this.isLoadingChangeSub.next(false);
          } else {
            this.toastr.success(response.message);
            this.isLoadingChangeSub.next(false);
            // this.router.navigate(["/merchant-list"]);
          this.initForm();
          }
        },
        (error) => {
          const message = this.ApiService.errorMessage(error)
          this.toastr.error(message);
          this.isLoadingChangeSub.next(false);
        }
      );
    } else {
      this.f.markAllAsTouched();
      window.scroll(0, 0);
    }
  }



  initForm() {
    this.faForm = this.fb.group({
      username: ['', [Validators.required, noWhiteSpaceValidator]],
    })
  }

  get f() {
    return this.faForm;
  }
  goBack() {
    this.router.navigate(["/merchants"], { relativeTo: this.route });
  }

}
